<template>
  <div style="position: relative">
    <swiper
      :options="swiperOption"
      ref="mySwiper"
      style="height: 100%; width: 100%"
      v-if="ready"
    >
      <!-- slides -->
      <swiper-slide v-for="(slide, index) in slideList" :key="index">
        <div class="primary white--text">
          <div class="d-flex align-center justify-center pt-8 pb-8">
            <SvgIcon :icon="slide.icon" height="240px" fill="#C6E1E5"></SvgIcon>
          </div>
          <div
            style="height: 100px"
            class="d-flex align-center flex-column justify-center"
          >
            <p
              class="title font-weight-bold text-center"
              v-if="index === 0"
              style="color: #C6E1E5"
            >
              ¡Bienvenido!
            </p>
            <p class="body-1 font-weight-medium text-center">
              {{ slide.text }}
            </p>
          </div>
          <div class="d-flex justify-center pb-4">
            <v-btn
              color="#c0e2e6"
              class="mb-10 secondary--text"
              width="130"
              large
              rounded
              @click="goNextSlide"
            >
              {{ index !== slideList.length - 1 ? "Siguiente" : "Aceptar" }}
            </v-btn>
          </div>
        </div>
      </swiper-slide>

      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-scrollbar" slot="scrollbar"></div>
    </swiper>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon";

export default {
  components: { SvgIcon },
  data: () => ({
    slideList: [
      {
        icon: "cp-outlined-fish-2",
        text: "Navega y personaliza tu perfil"
      },
      {
        icon: "cp-outlined-map",
        text: "Ingresa tus registros y avistamientos"
      },
      {
        icon: "cp-outlined-diver-2",
        text: "Busca buceos por zonas geográficas"
      },
      {
        icon: "cp-outlined-fish-1",
        text: "Explora nuestra biblioteca virtual"
      }
    ],
    swiperOption: {
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true
      }
    },
    ready: false
  }),
  methods: {
    goNextSlide() {
      if (
        this.$refs.mySwiper.swiper.activeIndex ===
        this.slideList.length - 1
      ) {
        return this.$emit("done");
      }
      this.$refs.mySwiper.swiper.slideTo(
        this.$refs.mySwiper.swiper.activeIndex + 1,
        400,
        false
      );
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.ready = true;
    });
  }
};
</script>

<style></style>
